import styled from 'styled-components';
import { HeaderWrapper } from '../HeaderWrapper/HeaderWrapper';
import CoveragesGrill from './components/CoveragesGrill/CoveragesGrill';
import CoveragesCard from './components/CoveragesCard/CoveragesCard';
import { coverages } from '../../models/coverages';
import { Paragraph } from '../Paragraph/Paragraph';
import coveragesBottomImage from '../assets/CoveragesImage.png';
import Triangle from '../Triangle/Triangle';
import { useWindowWidth } from '../../../../../hooks/useWindowWidth';
import { useState } from 'react';

function Coverages() {
  const titleText = 'You enjoy your stay.<br/>We cover the rest.';
  const paragraphText =
    'Our insurance makes your life easier with the following essential travel coverage:';

  const anchorId = 'coverage_leyend_link';
  const bottomText = `If you want to go even deeper into the coverage and limits 
  <a id="${anchorId}" target="_blank" href="https://main.oncampusabroad.com/media/documents/OnCampusAbroad_Table-of-Contents.pdf">
    read the summary of benefits.
  </a>`;

  const width = useWindowWidth();
  const isMobile = width < 768;

  const [openCardId, setOpenCardId] = useState<string | null>(null);

  return (
    <Background>
      <Triangle />
      <HeaderWrapper color='light' titleText={titleText} paragraphText={paragraphText} />
      <CoveragesGrill>
        {coverages.map((coverage) => (
          <CoveragesCard
            key={coverage.id}
            icon={coverage.icon}
            title={coverage.title}
            description={coverage.description}
            id={coverage.id}
            {...(isMobile && {
              isOpen: openCardId === coverage.id,
              onToggle: () => setOpenCardId((prev) => (prev === coverage.id ? null : coverage.id)),
            })}
          />
        ))}
      </CoveragesGrill>
      <Paragraph text={bottomText} color='light' />
      <Triangle orientation='bottom' />
      <ImageWrapper>
        <BottomImage src={coveragesBottomImage} alt='Bottom illustration' />
      </ImageWrapper>
    </Background>
  );
}

export default Coverages;

const Background = styled.div`
  width: 100%;
  background-color: #242c7c;
  padding: 4rem 1rem;
   
  position: relative;
  padding-bottom: 80px;

  @media (min-width: 500px) {
    padding-bottom: 120px;
  }

  @media (min-width: 650px) {
    padding-bottom: 180px;
    padding: 4rem 2rem;
  }

  @media (min-width: 768px) {
    padding-bottom: 200px;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 0px;
  bottom: -100px;
  left: 0;
  padding: 0 32px;
`;

const BottomImage = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
  z-index: 1;
`;
